import { createSlice } from '@reduxjs/toolkit';

export const dataYearSlice = createSlice({
    name: 'dataYear',
    initialState: {
        data: null,
        spesaMaxMese: null,
        spesaAvgMese: null,
        kwhMaxMese: null,
        kwhAvgMese: null,
        fasce: null,
        priceKwhAvgYear: null,
        letture: null,
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload
        },
        setSpesaAvg: (state, action) => {
            state.spesaAvgMese = action.payload
        },
        setSpesaMax: (state, action) => {
            state.spesaMaxMese = action.payload
        },
        setKwhAvg: (state, action) => {
            state.kwhAvgMese = action.payload
        },
        setKwhMax: (state, action) => {
            state.kwhMaxMese = action.payload
        },
        setFasce: (state, action) => {
            state.fasce = action.payload
        },
        setPriceKwhAvgYear: (state, action) => {
            state.priceKwhAvgYear = action.payload
        },
        setLetture: (state, action) => {
            state.letture = action.payload
        }
   
    }
});
export const {setLetture, setPriceKwhAvgYear, setFasce, setData, setSpesaAvg, setSpesaMax,setKwhAvg,setKwhMax} = dataYearSlice.actions;
export default dataYearSlice.reducer;